// RISING ATELIER — Core JS
document.addEventListener('DOMContentLoaded', () => {
  initDrawer();
  initModal();
  initHeaderScroll();
});

/* Drawer (for mobile nav, cart, etc.) */
function initDrawer() {
  const triggers = document.querySelectorAll('[data-drawer-open]');
  const closes = document.querySelectorAll('[data-drawer-close]');

  triggers.forEach(t => {
    t.addEventListener('click', () => {
      const target = document.querySelector(t.dataset.drawerOpen);
      target?.classList.add('open');
    });
  });

  closes.forEach(c => {
    c.addEventListener('click', () => {
      c.closest('.drawer')?.classList.remove('open');
    });
  });
}

/* Modal */
function initModal() {
  const triggers = document.querySelectorAll('[data-modal-open]');
  const closes = document.querySelectorAll('[data-modal-close]');

  triggers.forEach(t => {
    t.addEventListener('click', () => {
      const target = document.querySelector(t.dataset.modalOpen);
      target?.classList.add('open');
    });
  });

  closes.forEach(c => {
    c.addEventListener('click', () => {
      c.closest('.modal')?.classList.remove('open');
    });
  });
}

/* Header scroll behavior */
function initHeaderScroll() {
  const header = document.querySelector('header');
  if (!header) return;

  let last = 0;
  window.addEventListener('scroll', () => {
    const y = window.scrollY;
    if (y > last && y > 80) header.classList.add('hide');
    else header.classList.remove('hide');
    last = y;
  });
}
